import type { ApiErrorBody } from '@/api/client'
import { useCallback, useState } from 'react'
import { ApiError } from '@/api/client'

export function useServerErrors() {
  const [serverErrors, setServerErrors] = useState<ApiErrorBody['errors']>()

  const handleMutationError = useCallback((error: Error) => {
    if (error instanceof ApiError && error.status === 422 && error.body.errors) {
      setServerErrors(error.body.errors)
    }
  }, [])

  const clearServerErrors = useCallback(() => {
    setServerErrors(undefined)
  }, [])

  return { serverErrors, handleMutationError, clearServerErrors }
}
